define([], function(){
    var zh = {
        detail: {name: '案例展示'},
        topBarLinks: [
            {name: '上海客厅预约', class: 'sh-appoint'},

            // {name: '如何购买', link: '/shop'},
            // {name: 'vr逛店', link: 'https://realsee.com/lianjia/ZBgxP9kO80L9RNnl/qk0a74LqNmzkSxh6hVtPzBKjfr89MBpA/?from=groupmessage&isappinstalled=0',img: '/view-v2/web/static/img/common/vrnew.png'},
            {name: '联系我们', link: '/site/cooperate'}
        ],
        headLeft: {
            brand: '品牌',
            crest: '山脊线',
            earth: '大地线',
            ff: 'FF线',
            register: '注册',
            login: '登录',
            logout: '注销',
            cart: '购物车',
            order: '订单'
        },
        // navMenu: [
        //     {name: '首页', link: '/', menu: []},
        //     {name: '家具', link: '',category: '1',
        //         menu: [{name: '全部',link: '/furniture?tab=all'},
        //                 {name: '椅',link: '/furniture?tab=all#chair'},
        //                 {name: '桌',link: '/furniture?tab=all#desk'},
        //                 {name: '床',link: '/furniture?tab=all#bed'},
        //                 {name: '几',link: '/furniture?tab=all#lowtable'},
        //                 {name: '柜',link: '/furniture?tab=all#cab'},
        //                 {name: '沙发',link: '/furniture?tab=all#sofa'},
        //                 {name: '一枚板',link: '/furniture?tab=all#ymb'},
        //                 {name: '其他',link: '/furniture?tab=all#other'},
        //             ],
        //         newMenu: [{name: '大地线',link: '/furniture-l2?bom=base'},
        //             {name: '山脊线',link: '/furniture-l2?bom=high'},
        //             {name: 'FF线',link: '/furniture-l2?bom=ff'}
        //         ]},
        //     {name: '家居', link: '',category: '2', menu:
        //             [{name: '全部',link: '/grocery?tab=all'},
        //                 {name: '灯具',link: '/grocery-l2?bom=C01-11'},
        //                 {name: '家纺',link: '/grocery-l2?bom=C01-12'},
        //                 {name: '餐厨用品',link: '/grocery-l2?bom=C01-13'},
        //                 {name: '收纳杂物',link: '/grocery-l2?bom=C01-14'},
        //                 {name: '香氛洗护',link: '/grocery-l2?bom=C01-15'},
        //                 {name: '装饰',link: '/grocery-l2?bom=C01-16'},
        //                 {name: '家居电器',link: '/grocery-l2?bom=C01-17'},
        //                 {name: '户外园艺',link: '/grocery-l2?bom=C01-18'},
        //                 {name: '文创',link: '/grocery-l2?bom=C01-19'}
        //                 // {name: '备品',link: '/grocery-l2?bom=C01-99'}
        //             ]},
        //     {name: '艺术', link: '/gallery', menu:
        //             [
        //                 // {name:"艺术家", link:"/gallery#artist"},
        //                 // {name:"作品", link:"/gallery#works"},
        //                 // {name:"展览", link:"/gallery#exhibit"}
        //             ]},
        //     {name: '栏目', link: '',menu: [
        //             {name:"全部", link:"/home"},
        //             {name:"梵几在家", link:"/home#home"},
        //             {name:"串门", link:"/home#drop"},
        //             // {name:"ARTSTAGE", link:"/home#artist"}
        //         ]},
        //     {name: '关于梵几', link: '/fnjinews', menu: []},
        //     {name: '如何购买', link: '/buyChannel', menu: []}
        // ],
        // navMenu: [
        //     {name: '首页', link: '/', menu: []},
        //     {name: '家具', link: '',category: '1',
        //          menu: [{name: '全部',link: '/furniture?tab=all'},
        //                 {name: '椅',link: '/furniture?tab=all#chair'},
        //                 {name: '桌',link: '/furniture?tab=all#desk'},
        //                 {name: '床',link: '/furniture?tab=all#bed'},
        //                 {name: '几',link: '/furniture?tab=all#lowtable'},
        //                 {name: '柜',link: '/furniture?tab=all#cab'},
        //                 {name: '沙发',link: '/furniture?tab=all#sofa'},
        //                 {name: '一枚板',link: '/furniture?tab=all#ymb'},
        //                 {name: '其他',link: '/furniture?tab=all#other'},
        //             ],
        //          newMenu: [{name: '新品',link: '/furniture-l2?bom=recommend'},
        //                  {name: '大地线',link: '/furniture-l2?bom=base'},
        //                  {name: '山脊线',link: '/furniture-l2?bom=high'},
        //                  {name: 'FF线',link: '/furniture-l2?bom=ff'},
        //                  // {name: '回顾',link: '/furniture-l2?bom=ff'}
        //              ]},
        //     {name: '家居', link: '',category: '2', menu:
        //             [{name: '全部',link: '/grocery?tab=all'},
        //                 {name: '灯具',link: '/grocery-l2?bom=C01-11'},
        //                 {name: '家纺',link: '/grocery-l2?bom=C01-12'},
        //                 {name: '餐厨用品',link: '/grocery-l2?bom=C01-13'},
        //                 {name: '收纳杂物',link: '/grocery-l2?bom=C01-14'},
        //                 {name: '香氛洗护',link: '/grocery-l2?bom=C01-15'},
        //                 {name: '装饰',link: '/grocery-l2?bom=C01-16'},
        //                 {name: '家居电器',link: '/grocery-l2?bom=C01-17'},
        //                 {name: '户外园艺',link: '/grocery-l2?bom=C01-18'},
        //                 {name: '文创',link: '/grocery-l2?bom=C01-19'}
        //                 // {name: '备品',link: '/grocery-l2?bom=C01-99'}
        //             ]},
        //     {name: 'ART', link: '/gallery', menu:
        //             [
        //                 // {name:"展览", link:"/gallery#artist"},
        //                 // {name:"橱窗", link:"/gallery#works"},
        //                 // {name:"快闪", link:"/gallery#exhibit"}
        //             ]},
        //     {name: 'JOURNAL', link: '',menu: [
        //             {name:"全部", link:"/home"},
        //             {name:"梵几在家", link:"/home-athome"},
        //             {name:"串门", link:"/home-drop"},
        //             // {name:"ARTSTAGE", link:"/home#artist"}
        //         ]},
        //     // {name: 'PROJECT', link: '',menu: []},
        //     {name: '关于梵几', link: '/fnjinews', menu: []},
        //     {name: '如何购买', link: '/buyChannel', menu: []}
        // ],
        navMenu: [
            {name: '首页', link: '/', children: []},
            {name: '家具', link: '/furniture?tab=C09',category: '1', children: []},
            {name: '家居', link: '/grocery?tab=G01',category: '2', children: []},
            {name: '案例', link: '/caseNew', children: [
                    {name: '梵几在家',link: '/athome',type: 1},
                    {name: '商业',link: '/project',type: 2}
                ]},
            {name: '实体展厅', link: '/shops', children: [
                    {name: '北京·梵几三里屯太古里店',phoneTitle: '北京',phoneName: '三里屯太古里店',link: '/exhibitionhall?id=2',type: 1},
                    {name: '北京·梵几颐堤港店',phoneTitle: '',phoneName: '颐堤港店',link: '/exhibitionhall?id=3',type: 1},
                    {name: '北京·梵几客厅国子监店（升级中）',phoneTitle: '国子监店（升级中）',phoneName: '',link: '/exhibitionhall?id=4',type: 1},
                    {name: '上海·梵几上海前滩太古里店',phoneTitle: '上海',phoneName: '前滩太古里店',link: '/exhibitionhall?id=5',type: 2},
                    {name: '上海·梵几客厅武康路店',phoneTitle: '',phoneName: '武康路店',link: '/exhibitionhall?id=6',type: 2},
                    {name: '广州·梵几广州粤海天地店',phoneTitle: '广州',phoneName: '粤海天地店',link: '/exhibitionhall?id=7',type: 3},
                    {name: '深圳·梵几万象前海店',phoneTitle: '深圳',phoneName: '万象前海店',link: '/exhibitionhall?id=8',type: 4},
                    {name: '深圳·梵几卓越中心店',phoneTitle: '',phoneName: '卓越中心店',link: '/exhibitionhall?id=9',type: 4},
                    // {name: '成都·梵几远洋太古里店',link: '/exhibitionhall?id=10',type: 5},
                    {name: '杭州·梵几留和路店',phoneTitle: '杭州',phoneName: '留和路店',link: '/exhibitionhall?id=11',type: 6},
                    {name: '苏州·梵几苏州诚品店',phoneTitle: '苏州',phoneName: '诚品店',link: '/exhibitionhall?id=12',type: 7},
                    // {name: '苏州·梵几苏州春风里店',link: '/exhibitionhall?id=13',type: 7},
                    {name: '南京·梵几南京金鹰世界店',phoneTitle: '南京',phoneName: '金鹰世界店',link: '/exhibitionhall?id=14',type: 8},
                    {name: '成都·梵几成都富森店',phoneTitle: '成都',phoneName: '富森店',link: '/exhibitionhall?id=15',type: 5},
                    {name: '西安·梵几西安万象城店',phoneTitle: '西安',phoneName: '万象城店',link: '/exhibitionhall?id=16',type: 9}
                ]},
            {name: '艺术/栏目', link: '/gallery', children: [
                    {name: '艺术展览·艺术橱窗·艺术快闪',link: '/gallery',type: 1,phoneChildren: [
                            {name: '艺术展览',link: '/gallery'},
                            {name: '艺术橱窗',link: '/gallery'},
                            {name: '艺术快闪',link: '/gallery'}
                        ]},
                    {name: '串门',link: '/home-drop',type: 2}
                ]},
            // {name: '栏目', link: '/home'},
            {name: '关于梵几', link: '/fnjinews', children: []},
            {name: '下载区', link: '/download', children: [
                    {name: '产品模型',link: '/download',type: 1},
                    {name: '产品册',link: '/catalog',type: 2},
                ]},
            {name: '如何购买', link: '/buyChannel', children: []}
        ],
        footerNew: [
            {name: '媒体报道', link: '/fnjimedia'},
            {name: '招聘信息', link: '/job'},
            {name: '售后服务', link: '/aboutservice'},
            {name: '联系我们', link: '/site/cooperate?type=1'}
        ],
        menuGroups: [
            {
                title: '关于我们',
                list: [
                    {name: '关于梵几', link: '/fnjinews'},
                    {name: '如何购买', link: '/buyChannel'},
                    {name: '媒体报道', link: '/fnjimedia'},
                    {name: '招聘信息', link: '/job'}
                ]
            },
            {
                title: '购物指南',
                list: [
                    {name: '购物流程', link: '/howshop'},
                    {name: '会员制度', link: '/membership'}
                ]
            },
            {
                title: '关于配送',
                list: [
                    {name: '家具配送', link: '/aboutdeliver?index=0'},
                    {name: '家居配送', link: '/aboutdeliver?index=1'},
                    {name: '一枚板配送', link: '/aboutdeliver?index=2'}
                ]
            },
            {
                title: '售后服务',
                list: [
                    {name: '家具售后', link: '/aboutservice?index=0'},
                    {name: '家居售后', link: '/aboutservice?index=1'}
                ]
            },
            {
                title: '联系我们',
                list: [
                    {name: '项目批量采购', link: '/site/cooperate?type=1'},
                    {name: '设计公司合作', link: '/site/cooperate?type=2'},
                    {name: '家居品牌合作', link: '/site/cooperate?type=3'},
                    {name: '市场&媒体合作', link: '/site/cooperate?type=4'},
                    {name: '艺术品合作', link: '/site/cooperate?type=5'},
                    {name: '产品目录下载', link: '/temp/upload/productinfo/产品目录.zip'}
                ]
            }
        ],
        fnjiIndexNew: {
            aboutFnji: '关于梵几',
            // aboutFnjiCon: '“生长于野，安于室”是梵几扎根东方土壤的理念传达，取自然之材，拟自然之态，使其共生与传承。',
            // aboutFnjiCon2: '梵几希望在设计与生活、东方与西方、现代与未来之间找到一种平衡，将自然带入居家空间中，',
            // aboutFnjiCon3: '并成为人们日常生活里的长久陪伴。',
            aboutFnjiCon: '梵几创立于2010年，是集家具与家居为一体的生活美学品牌。“梵”是净空与安静的意思，“几”是家具，',
            aboutFnjiCon2: '意为净空安静的家具，同时梵几的谐音是“凡几”一平凡的家具。“东方现代，自然隽永”是品牌的关键词，',
            aboutFnjiCon3: '是梵几扎根东方土壤、不断探索美学生活的理念和坚持。“生长于野，安于室”，取自然之材，拟自然之态。',
            aboutFnjiCon4: '梵几坚持以木为主体，融合皮、羊毛、石材等多种自然材质，将取诸山野的灵气回归日常生活之中。',
            aboutFnjiBt: '更多关于梵几',
            furnitureTitle: '家具',
            furniture: '梵几家具围绕生野安室的理念，融合深沉肃穆、简单质朴、现代多元等多种设计语言',
            furniture2: '探索东方与西方之间、现代与传统之间、记忆与未来之间的美学平衡与灵感世界',
            earth: '大地线',
            earthInfo: '简练淳厚  如无垠大地',
            crest: '山脊线',
            crestInfo: '沉穆缥缈，如云上山影',
            fnjiFore: 'FF线',
            fnjiForeInfo: '探索中国未来生活的可能',
            moreFur: '更多家具',
            fnjiathome: '梵几在家',
            fnjiathomeCon: '为了深入探索家具主人的生活态度，观察家具与人',
            fnjiathomeCon2: '人与人之间的亲密连结，梵几自制栏目“梵几在家”',
            fnjiathomeCon3: '从不同维度出发，讲述家具，设计与人的故事',
            cooperation: '商业',
            cooperationCon: '梵几与商业空间、设计师及主理人产生联动，在不同风格中共同演绎梵几家具的包容度',
            cooperationCon2: '与无限可能性。',
            furnishings: '家居',
            homeCon: '甄选源自全球的家居好物，用充盈细节点缀家中空间，勾勒质感生活的完满形态',
            homeCon2: '将梵几认可、推崇的生活美学体系更加极致地呈现出来',
            moreHome: '更多家居',
            artTitle: '艺术/栏目',
            artCon: 'ART包含艺术展览、艺术橱窗以及快闪等多个艺术相关活动',
            artCon2: '梵几拓展传统艺术的界限，挖掘艺术的无限可能性，让观众感知以不同载体呈现的艺术',
            artCon3: '并带领他们进入无限遐想的艺术世界',
            moreInfo: '更多详情',
            journalCon: '为了深入探索家具主人的生活态度，观察家具与人、人与人之间的亲密连结，梵几自制栏目“梵几在家”、“串门”，',
            journalCon2: '从不同维度出发，讲述家具，设计与人的故事。',
            projectCon: '梵几与商业空间、设计师及主理人产生联动，在不同风格中共同演绎梵几家具的包容度',
            projectCon2: '与无限可能性。',
            morePro: '更多项目',
            howtobuy: '如何购买',
            lineStore: '线上店铺',
            lineStores: '| 天猫 | 京东 | 微信小程序 |',
            phyStore: '实体门店',
            phyStores: ['北京','上海','广州','深圳','成都','杭州','苏州','南京'],
            aboutAllBt: '查看全部购买方式',
            footerInfo: '探寻东方与西方之间',
            footerInfo2: '现代与传统之间',
            footerInfo3: '记忆与未来之间的美学平衡与灵感世界'
        },
        fnjiIndexPhoneNew: {
            // aboutFnjiCon: '“生长于野，安于室”是梵几扎根东方土壤的理念传',
            // aboutFnjiCon2: '达，取自然之材，拟自然之态，使其共生与传承。梵',
            // aboutFnjiCon3: '几希望在设计与生活、东方与西方、现代与未来之间',
            // aboutFnjiCon4: '找到一种平衡，将自然带入居家空间中，并成为人们',
            // aboutFnjiCon5: '日常生活里的长久陪伴。',
            aboutFnjiCon: '梵几创立于2010年，是集家具与家居为一体的生活美学',
            aboutFnjiCon2: '品牌。“梵”是净空与安静的意思，“几”是家具，意为净',
            aboutFnjiCon3: '空安静的家具，同时梵几的谐音是“凡几”一平凡的家具。',
            aboutFnjiCon4: '“东方现代，自然隽永”是品牌的关键词，是梵几扎根东',
            aboutFnjiCon5: '方土壤、不断探索美学生活的理念和坚持。“生长于野，',
            aboutFnjiCon6: '安于室”，取自然之材，拟自然之态。梵几坚持以木为主',
            aboutFnjiCon7: '体，融合皮、羊毛、石材等多种自然材质，将取诸山野的',
            aboutFnjiCon8: '灵气回归日常生活之中。',
            furniture: '梵几家具围绕生野安室的理念，融合深沉肃',
            furniture2: '穆、简单质朴、现代多元等多种设计语言，探',
            furniture3: '索东方与西方之间、现代与传统之间、记忆与',
            furniture4: '未来之间的美学平衡与灵感世界',
            homeCon: '甄选源自全球的家居好物，用充盈细节点缀家',
            homeCon2: '中空间，勾勒质感生活的完满形态，将梵几认',
            homeCon3: '可、推崇的生活美学体系更加极致地呈现出来',
            fnjiathomeCon: '为了深入探索家具主人的生活态度，观察家具与人',
            fnjiathomeCon2: '人与人之间的亲密连结，梵几自制栏目“梵几在家”',
            fnjiathomeCon3: '从不同维度出发，讲述家具，设计与人的故事',
            cooperationCon: '梵几与商业空间、设计师及',
            cooperationCon2: '主理人产生联动，在不同风格中共同演绎',
            cooperationCon3: '梵几家具的包容度与无限可能性。',

            fnjiAtHomeDesc:'为了深入探索家具主人的生活态度，观察家具与人\n' +
                '人与人之间的亲密连结，梵几自制栏目“梵几在家”\n' +
                '从不同维度出发，讲述家具，设计与人的故事',

            fnjiProjectDesc: '梵几与商业空间、设计师及主理人产生联动，在不同风格中共同演绎梵几家具的包容度\n' +
                '与无限可能性。',
            fnjiProject: '商业',

            EXHIBITION: '展览',
            EXHIBITION2: 'EXHIBITION',
            ARTSTAGE: '橱窗',
            ARTSTAGE2: 'ART STAGE',
            STORE: '快闪店',
            STORE2: 'POP-UP STORE',
            artCon: 'ART包含艺术展览、艺术橱窗以及快闪等多个',
            artCo2: '艺术相关活动梵几拓展传统艺术的界限，挖掘',
            artCon3: '艺术的无限可能性，让观众感知以不同载体呈',
            artCon4: '现的艺术，并带领他们进入无限遐想的艺术世',
            artCon5: '界。',
            journalCon: '为了深入探索家具主人的生活态度，观察家具',
            journalCon2: '与人、人与人之间的亲密连结，梵几自制栏目',
            journalCon3: '“梵几在家”、“串门”，从不同维度出发，',
            journalCon4: '讲述家具，设计与人的故事。',
            projectCon: '梵几与商业空间、设计师及主理人产生联动，',
            projectCon2: '在不同风格中共同演绎梵几家具的包容度与无',
            projectCon3: '限可能性。',
        },
        aboutFnjiNew: {
            titleOne: '记忆',
            titleTwo: '传承',
            titleThree: '自然',
            titleFour: '隽永',
            memory: '梵几的设计灵感源于对中国文化与传统生活的感知，将东方韵味与哲思凝练于设计中。把中国人的共同记',
            memory2: '忆和文化共鸣以符合现代生活方式的设计语言传达出来，让记忆中逐渐消逝的过去，以新的方式长久地存',
            memory3: '在于当今人们的生活中，留住记忆里的烟火气。',
            productsImg: [
                {img:'s20480_1627452972_1499.png',name: '竹椅',ename: ' BAMBOO CHAIR',info1: '以木代替竹子，外形经过提炼与简化，线条呈现粗细变化，简洁质朴中流动着',info2: '中式意蕴，是梵几品牌的开端。'},
                {img:'s20480_1627452940_9411.png',name: '团扇屏风',ename: ' CIRCULAR FAN SCREEN',info1: '木与藤虚实交错，空气流转之间，让传统中式元素融入现代的空间动线和生活方式，',info2: '空间隔断不再是一种切割，而是成为一种人与人之间既可交流、又相互独立的关系。'},
                {img:'s20480_1627452916_7972.png',name: '胡同推车',ename: ' LITTLE CART',info1: '以中国传统的竹推车为灵感依托，用中式特有的设计语言回归记忆中最质朴的',info2: '空间需求，不为家具功能所限定，灵活适用于家中的各个空间和场景。'},
                {img:'s20480_1627452875_7826.png',name: '线轴几',ename: ' REEL SIDE TABLE',info1: '细腻变化的自然石材肌理形成更加丰富的触感，',info2: '高低错落组合衬出独具灵气的东方美。'},
                {img:'s20480_1627452846_8757.png',name: 'CIGAR置物架',ename: ' CIGAR DISPLAY SHELF',info1: '取竹编簸箕架之形，又灌之以现代设计的巧思，四个方向均可拿取和展示物',info2: '品，纵横交错中勾勒出重叠的美感。'},
                {img:'s20480_1627452815_5473.png',name: '马扎',ename: ' CAMPSTOOL',info1: '圆滑细腻的木质架构形成可随身提携的拎手，色泽温润的植鞣坐面注入时间的',info2: '自然印记。'},
                {img:'s20480_1627452661_7271.png',name: '鸟笼立柜',ename: ' CAGE CABINET',info1: '参照鸟笼的笼体，厚实且造型独特的木条温润包围，柔和灯光中呈现虚实互通',info2: '的视觉体系。'}
            ],
            inheritance: '传承中国传统工艺，通过木工匠人的亲手打磨，保留木材原生纹理与质感。为了在结构、性能和感官上凝',
            inheritance2: '聚最佳的体验，每一道工艺都承载着梵几追寻的情感表达。是对中国传统技艺的传承与保护，也是对设计',
            inheritance3: '的极致追求。',
            nature: '人与自然的亲近感是与生俱来的，契合“生于野，安于室”的本质，坚持以实木为主体，融合皮、羊毛、',
            nature2: '石材等多种自然材质，将取诸山野的灵气回归日常生活之中。甄选世界级品牌进口材料，保障安全与环',
            nature3: '保的同时经久耐用。',
            timeLess: '什么才是真正属于中国的设计——是梵几一直以来的思考与探索。',
            timeLess2: '每一个设计背后，都隐藏着对自然万物与人文艺术的大爱与珍视。',
            events: '梵几事件',
            commercials: '历年广告回顾',
            commercialsInfo: '十年间，除了探寻自身产品的可能性，我们也同样思考产品多样的视觉呈现。这是梵几对艺术美感的思考，也同样是',
            commercialsInfo2: '品牌精神的表达。梵几希望，在东方与西方之间，当代与传统之间，记忆与未来之间，取得一种平衡，进而探索属于',
            commercialsInfo3: '中国人未来的家具。',
            designer: '梵几设计师'
        },
        aboutFnjiPhoneNew: {
            memory: '梵几的设计灵感源于对中国文化与传统生活',
            memory2: '的感知，将东方韵味与哲思凝练于设计中。',
            memory3: '把中国人的共同记忆和文化共鸣以符合现代',
            memory4: '生活方式的设计语言传达出来，让记忆中逐',
            memory5: '渐消逝的过去，以新的方式长久地存在于当',
            memory6: '今人们的生活中，留住记忆里的烟火气。',
            inheritance: '传承中国传统工艺，通过木工匠人的亲手',
            inheritance2: '打磨，保留木材原生纹理与质感。为了在',
            inheritance3: '结构、性能和感官上凝聚最佳的体验，每',
            inheritance4: '一道工艺都承载着梵几追寻的情感表达。',
            inheritance5: '是对中国传统技艺的传承与保护，也是对',
            inheritance6: '设计的极致追求。',
            nature: '人与自然的亲近感是与生俱来的，契合“生',
            nature2: '于野，安于室”的本质，坚持以实木为主体，',
            nature3: '融合皮、羊毛、石材等多种自然材质，将取',
            nature4: '诸山野的灵气回归日常生活之中。甄选世界',
            nature5: '级品牌进口材料，保障安全与环保的同时经',
            nature6: '久耐用。',
            timeLess: '什么才是真正属于中国的设计——是梵几一',
            timeLess2: '直以来的思考与探索。',
            timeLess3: '每一个设计背后，都隐藏着对自然万物与人',
            timeLess4: '文艺术的大爱与珍视。',
            commercialsInfo: '十年间，除了探寻自身产品的可能性，我们也',
            commercialsInfo2: '同样思考产品多样的视觉呈现。这是梵几对艺',
            commercialsInfo3: '术美感的思考，也同样是品牌精神的表达。梵',
            commercialsInfo4: '几希望，在东方与西方之间，当代与传统之间，',
            commercialsInfo5: '记忆与未来之间，取得一种平衡，进而探索属',
            commercialsInfo6: '于中国人未来的家具。',
        },
        artInfoNew: {

            artTypeList: [
                {id: '100',artType: '艺术展览',info: '梵几挖掘来自全世界的艺术家，邀请他们于全国梵几客厅举办艺术展览，并在现场进行交流及创作分享。当对极致美学的追求契合，热爱艺术的灵魂相碰撞，梵几让每一个来展的观众走近艺术。',
                    infoPhone1: '梵几挖掘来自全世界的艺术家，邀请他们于全国梵几客厅举办艺术展览，并在现场进行交流及创作分享。',infoPhone2: '当对极致美学的追求契合，热爱艺术的灵魂相碰撞，梵几让每一个来展的观众走近艺术。'},
                {id: '101',artType: '艺术橱窗',info: '梵几不定期邀请艺术家用[玩]的方式一起打造主题橱窗。它不被定义/是品牌与艺术家的跨界尝试与新奇实验。用想象力和艺术作品打造别致的视觉盛宴……',
                    infoPhone2: '梵几不定期邀请艺术家用[玩]的方式一起打造主题橱窗。它不被定义/是品牌与艺术家的跨界尝试与新奇实验。用想象力和艺术作品打造别致的视觉盛宴……'},
                {id: '102',artType: '艺术快闪',info: 'Pop-up Store 艺术快闪店主题目将邀请新颖、独特的品牌来梵几客厅做客，期待为梵几空间注入独特的视角与生活品味，在此场域空间中互相激荡、擦出火花，交流出更多的可能。',
                    infoPhone2: 'Pop-up Store 艺术快闪店主题目将邀请新颖、独特的品牌来梵几客厅做客，期待为梵几空间注入独特的视角与生活品味，在此场域空间中互相激荡、擦出火花，交流出更多的可能。'},
            ],
        },
        moreBtn: '查看更多',
        fnjiIndex: {
            aboutFnjiLogo: '/view-v2/web/static/img/index/fnji_about.png',
            indexFurnitureLogo: '/view-v2/web/static/img/index/fnji_furture.png',
            indexGroLogo: '/view-v2/web/static/img/index/fnji_gro_zh.png',
            indexArtLogo: '/view-v2/web/static/img/index/fnji_art.png',
            indexColumnLogo: '/view-v2/web/static/img/index/fnji_column_zh.png',
            indexHowBuyLogo: '/view-v2/web/static/img/index/fnji_how_buy_zh.png',

            aboutFnjiCon: '传承中国传统工艺，甄选优质自然材质，凝练记忆中的灵感，用世界级严苛标准，创造真正属于中国人的家具。',
            aboutFnjiBt: '了解更多梵几',
            aboutBt: '了解更多',
            aboutAllBt: '查看全部购买方式',
            furnitureLine: '| 山脊线 | 大地线 | FF线 |',
            crestInfo: '梵几山脊线系列的灵感来源于大自然以及儿时记忆，扎根中国传统文化，将更具东方空灵艺术性的元素融合深沉肃穆的设计语言。以螳螂椅为首款产品，历时3年，从设计、结构到工艺，不断推敲升级，采用大曲线，多细节的实木加工，配合国际品牌的面料，突出现代中国家具的雕塑感，艺术感以及为生活带来仪式感。',
            earthInfo: '梵几大地线，品牌中最早的一条线，关注寻常人家生活中真实所需的家居设计，简单质朴，在葆有中国的设计语言的基础上，将大自然中的树木变为与家相融的家具，在四季更迭中长久陪伴，慢慢变成我们的家人。',
            ffInfo: 'FF=Fnji Fore，代表梵几向前一步，是梵几品牌全新实验性的产品线。有别于延续传统工艺探索的设计，FF系列在设计语言上更为简洁直接， 以多元材质和工艺结合赋予家具更多可能，现代简约而不失温度感。',
            groceryInfo: '家居馆延续生野安室的理念，用挑剔的品位甄选源自全球的家居好物。',
            groceryInfo2: '美好家居品可以提升幸福感，增加仪式感，与家具完美搭配，亦是过节送礼的佳选。',
            groceryInfo3: '更重要的是，它们将梵几认可、推崇的生活美学体系更加极致地呈现出来。',
            galleryInfo: '梵几艺术画廊包含艺术展览、艺术橱窗以及快闪等多个艺术相关活动。',
            galleryInfo2: '梵几拓展传统艺术的界限，挖掘艺术的无限可能性，让观众感知以不同载体呈现的艺术，',
            galleryInfo3: '并带领他们进入无限遐想的艺术世界。',
            columnInfo: '为了深入探索家具主人的生活态度，观察家具与人、人与人之间的亲密连结，梵几自制栏目“梵几在家”、“串门”，从不同维度出发，讲述家具，设计与人的故事。',
            phyStore: '实体门店',
            phyStores: '| 北京 | 上海 | 广州 | 深圳 | 成都 | 杭州 | 苏州 | 南京 |',
            lineStore: '线上店铺',
            lineStores: '| 天猫 | 京东 | 微信小程序 |',
            indexDown: '/view-v2/web/static/img/index/index2020_zh.png',
            indexDown2: ''
        },
        catalog: {
            name: '产品册',
            btn: '点击下载产品册'
        },
        aboutFnji: {
            aboutFnji1Title: '十年雕琢 初心未改',
            aboutFnji1: '梵几由设计师高古奇创立于2010年，是中国原创家具的先锋代表。“梵”是净空与安静，“几”是家具，意为净空安静的家具。“什么才是真正属于中国的设计”是梵几一直以来的思考与探索。',
            aboutFnji2Title: '传承中国 传统工艺',
            aboutFnji2: '通过木工匠人的亲手打磨，保留木材原生纹理与质感。每一处转角和线条的细节处理，非十年功底不可得。是对中国传统技艺的传承与保护，也是对设计的极致追求。',
            aboutFnji3Title: '甄选优质 自然材质',
            aboutFnji3: '坚持以实木为主体，融合皮、羊毛、石材等多种自然材质。选用世界级品牌进口材料，保障安全与环保的同时经久耐用。契合“生于野，安于室”的本质，回归自然与练达。',
            aboutFnji4Title: '凝练记忆中的灵感',
            aboutFnji4: '设计不应只是线条与元素的堆砌，梵几的设计灵感源于对中国文化与传统生活的感知，将东方韵味与哲思凝练于设计中。每一个设计背后，都隐藏着对自然万物与人文艺术的大爱与珍视。',
            aboutFnji5Title: '十年 寻河',
            aboutFnji5: '十年。寻河。',
            aboutFnji51: '“不知道从什么时候开始，我经常做一个类似的梦。梦里的自己在寻找一条河，那条河清澈见底，应该就在不远处。',
            aboutFnji52: '但这也许只是我梦中的景象，',
            aboutFnji53: '那条河，我仍未找到。”',
            aboutFnji54: '梵几从创立到不断变得完整，也如同一场寻河之旅。'
        },
        cooperateItem: [
            { title: '项目批量采购', desc: '', type: 1, class: 'project'},
            { title: '设计公司合作', desc: '', type: 2, class: 'desgin'},
            { title: '家居品牌合作', desc: '', type: 3, class: 'grocery'},
            { title: '市场&媒体合作', desc: '', type: 4, class: 'marketing'},
            { title: '艺术品合作', desc: '', type: 5, class: 'gallery'}
        ],
        cooperateFnji: {
            topTitle: '商业合作',
            topCon: '梵几对外开放多方向商业合作，',
            topCon2: '如果您有合作意向请点击相应入口填写信息。',
            topCon3: '若有需要我们将会在5个工作日内回复您。',
            companyName: '公司名称',
            projectName: '项目名称',
            city: '城市',
            budget: '预算',
            time: '进场时间',
            contact: '联系人',
            position: '职务',
            phoneNumber: '电话',
            phone: '联系电话',
            companyIntro: '公司介绍',
            project: '合作项目',
            artistBrandstudio: '艺术家/品牌/工作室',
            summary: '简介',
            email: '邮箱',
            importantEmail: '邮箱（很重要，请填写常用邮箱）',
            attachFile: '添加附件',
            fileTips: '附件不得超过15M，支持jpg，pdf',
            note: '备注',
            submit: '提交',
            successfully: '提交成功'
        },
        fnjiAtHome: '[梵几在家] 是梵几品牌的自媒体栏目，透过栏目展现梵几家具在不同人家中的状态，分享家具不同的搭配使用，传达家具主人的生活态度......',
        fnjiVisitFriend: '2009年，梵几成立的前一年，古奇（梵几创始人兼主设计师）来到北京，那时和朋友们见面不是约在咖啡管就是商场，而小时候，父母友人间相互串门的方式让他难以忘怀，那时古奇就在朋友圈发起了一场“串门“活动......',
        addCart: '加入购物车',

        buyChannel:{
            online: '线上商城',
            project: '商业采购',
            shop: '实体门店',
        },
        buy: '直接购买',

        clickShow: {
            partOne: '点击查看',
            partTwo: '配送详情',
            partThree: '或',
            partFour: '会员制度'
        },
        usingClick: {
            partOne: '点击购买',
            partTwo: '家具保养套装'
        },
        artInfo: {
            artExhibtion1: '梵几挖掘来自全世界的艺术家，邀请他们于全国梵几客厅举办艺术展览，并在现场进行交流及创作分享。',
            artExhibtion2: '当对极致美学的追求契合，热爱艺术的灵魂相碰撞，梵几让每一个来展的观众走近艺术。',
            artExhibtionBtn: '查看全部展览',
            artStage1: '通过木工匠人的亲手打磨，保留木材原生纹理与质感',
            artStage2: '每一处转角和线条的细节处理，非十年功底不可得',
            artStage3: '是对中国传统技艺的传承与保护，也是对设计的极致追求',
            artStageBtn: '查看全部橱窗',
            artStore1: 'Pop-up Store 艺术快闪店主题目将邀请新颖、独特的品牌来梵几客厅做客，',
            artStore2: '期待为梵几空间注入独特的视角与生活品味，在此场域空间中互相激荡、擦出火花，交流出更多的可能。',
        },
        homeInfo: {
            homeTitle: '梵几在家',
            homeAtHome1: '梵几在家是梵几品牌的自媒体栏目，透过展现梵几家具在不同人家中的状态',
            homeAtHome2: '分享家具不同的搭配使用以及传达家具主人的生活态度',
            homeBtn: '查看全部',
            homeVisitTitle: '串门',
            homeVisit1: '2009年，梵几成立的前一年，古奇（梵几创始人兼主设计师）来到北京，那时和朋',
            homeVisit2: '友们见面不是约在咖啡馆就是商场，而小时候，父母友人间相互串门的方式让他难',
            homeVisit3: '以忘怀，那时古奇就在朋友圈发起了一场“串门“活动……'
        },
        homeInfoPhone: {
            homeAtHome1: '梵几在家是梵几品牌的自媒体栏目，',
            homeAtHome2: '透过展现梵几家具在不同人家中的状态。',
            homeAtHome3: '分享家具不同的搭配使用以及传达家具主人的生活态度。',
            homeVisit1: '2009年，梵几成立的前一年，古奇（梵几创始人兼主设',
            homeVisit2: '计师）来到北京，那时和朋友们见面不是约在咖啡馆就是',
            homeVisit3: '商场，而小时候，父母友人间相互串门的方让他难以忘',
            homeVisit4: '怀，那时古奇就在朋友圈发起了一场“串门“活动……'
        },
        typeList: [
            {name: '全部',tab: '',link: '/furniture?tab=all'},
            {name: '椅',tab: '#chair',link: '/furniture?tab=all#chair'},
            {name: '桌',tab: '#desk',link: '/furniture?tab=all#desk'},
            {name: '床',tab: '#bed',link: '/furniture?tab=all#bed'},
            {name: '几',tab: '#lowtable',link: '/furniture?tab=all#lowtable'},
            {name: '柜',tab: '#cab',link: '/furniture?tab=all#cab'},
            {name: '沙发',tab: '#sofa',link: '/furniture?tab=all#sofa'},
            {name: '一枚板',tab: '#ymb',link: '/furniture?tab=all#ymb'},
            {name: '其他',tab: '#other',link: '/furniture?tab=all#other'}
        ],
        newTypeList: [
            {name: '新品',tab: 'recommend',link: '/furniture-l2?bom=recommend'},
            {name: '大地线',tab: 'base',link: '/furniture-l2?bom=base'},
            {name: '山脊线',tab: 'high',link: '/furniture-l2?bom=high'},
            {name: 'FF线',tab: 'ff',link: '/furniture-l2?bom=ff'},
            // {name: '回顾',tab: '',link: '/furniture-l2?bom=ff'},
        ],
        groTypeList: [
            {theName: '全部',name: '全部',bom: '',link: '/grocery?tab=all'},
            {theName: '灯具',name: '灯具',bom: 'C01-11',link: '/grocery-l2?bom=C01-11'},
            {theName: '家纺',name: '家纺',bom: 'C01-12',link: '/grocery-l2?bom=C01-12'},
            {theName: '餐厨用品',name: '餐厨用品',bom: 'C01-13',link: '/grocery-l2?bom=C01-13'},
            {theName: '收纳杂物',name: '收纳杂物',bom: 'C01-14',link: '/grocery-l2?bom=C01-14'},
            {theName: '香氛洗护',name: '香氛洗护',bom: 'C01-15',link: '/grocery-l2?bom=C01-15'},
            {theName: '装饰',name: '装饰',bom: 'C01-16',link: '/grocery-l2?bom=C01-16'},
            {theName: '家居电器',name: '家居电器',bom: 'C01-17',link: '/grocery-l2?bom=C01-17'},
            {theName: '户外园艺',name: '户外园艺',bom: 'C01-18',link: '/grocery-l2?bom=C01-18'},
            {theName: '文创',name: '文创',bom: 'C01-19',link: '/grocery-l2?bom=C01-19'}
        ]
    };
    return  zh;
});



//////////////////
// WEBPACK FOOTER
// ../i18n/config/zh.js
// module id = 22
// module chunks = 0 1 2 3 4 5 6